import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    Dialog,
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Grid,
    Slide,
    Button
} from '@material-ui/core';
import { PictureAsPdf, NoteAdd } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';
import { toggleShowDialog } from '../../store/actions/dialog';
import If from '../condicional/if';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DialogFullScreen = props => {

    return (
        <Dialog
            fullScreen
            open={props.openDialog}
            slots={{
                transition: Transition,
            }}
        >
            <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={props.cancelButtonClick}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                    <Typography style={{ marginLeft: 10, flex: 1 }} variant="h6" component="div">
                        {props.title}
                    </Typography>
                    <If test={props.faturar}>
                        <Grid item style={{ padding: 5 }}>
                            <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<NoteAdd />}
                                onClick={props.faturarClick}
                            >
                                Faturar
                            </Button>
                        </Grid>
                    </If>
                    <If test={props.etiqueta}>
                        <Grid item style={{ padding: 5 }} >
                            <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<PictureAsPdf />}
                                onClick={props.etiquetaClick}
                            >
                                Etiqueta
                            </Button>
                        </Grid>
                    </If>
                    {/*
                    <If test={props.cancelButton}>
                        <Button onClick={props.cancelButtonClick} color="inherit">
                            {props.labelCancelButton}
                        </Button>
                    </If>
                    <If test={props.okButton}>
                        <Button onClick={() => props.okButtonClick(idDialogShow)} color='inherit' autoFocus>
                            {props.labelOkButton}
                        </Button>
                    </If>
                    */}
                </Toolbar>
            </AppBar>
            <Grid container item style={{ padding: 15, paddingTop: 50 }}>
                <Grid item xs >
                    {props.children}
                </Grid>
            </Grid>
        </Dialog>
    )
}

const mapStateToProps = state => ({ idDialogShow: state.dialog.idDialogShow })
const mapDispatchToProps = dispatch => bindActionCreators({ toggleShowDialog }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(DialogFullScreen)